import { IMIWorksheet } from "..";

interface IAlert {
    alertedAt: Date;
    strike_rate: number;
    current_mortgage_rate: number;
}

export interface IStrikeEvaluation {
    type: "rate" | "mi" | null;
    current_mortgage_rate: number | null;
    strike_rate: number | null;
    strike_at: Date | null;
    evaluated_at: Date;
}

// NOTE this is duplicated in calc library. Please updated there as well
export interface IStrikeRateTransaction {
    _id: string;
    alert_history: IAlert[];
    archived: boolean;
    buyer: {
        email?: string;
        first_name: string;
        last_name: string;
    };
    createdAt?: Date;
    updatedAt?: Date;
    interest_rate: number | null;
    interest_rate_overrides: {
        user_input: number | null;
        default_for_date: number | null;
    };
    last_alert: IAlert | null;
    loan_amount: number;
    loan_amount_overrides: {
        user_input: number | null;
    };
    loan_date: string;
    loan_due_date: string;
    loan_id: string;
    loan_term: string;
    loan_type: string;
    nmls_id: string;
    rate_type: string;
    rate_type_overrides: {
        user_input: string | null;
    };
    sold_date: string | null;
    strike_rate: number | null;
    strike_rate_overrides: {
        user_input: number | null;
    };
    user_id: string;
    sold_price: number | null;
    sold_price_overrides: {
        user_input: number | null;
    };
    address: string | null;
    city: string;
    county: string;
    fips: string;
    state: string;
    zip: string;
    estimated_home_value: number | null;
    estimated_home_value_overrides: {
        user_input: number | null;
    };
    current_balance: number | null;
    current_balance_overrides: {
        user_input: number | null;
    };
    loan_date_overrides: {
        user_input: string | null;
    };
    loan_typefinancing: string | null;
    MI: number | null;
    upfrontMI: number | null;
    MIWorksheet: IMIWorksheet;
    creditScore: number;
    original_ltv: number | null;
    source: string;
    hr_id: string | null;
    strike_evaluation: IStrikeEvaluation | null;
}

export interface IUserSettings {
    _id: string;
    payOffPeriodMonths: number;
    updatedAt: string;
    rateTriggers: {
        lowest: number;
        medium: number;
        highest: number;
    };
}

export interface IMortgageRate {
    _id: string;
    rate: number;
    type: string;
    date: string;
    source: string;
    avgPoints?: number;
    volume?: number;
    createdAt: string;
    updatedAt: string;
}

export interface IMortgageRatesMultiplier {
    _id: string;
    date: Date;
    multiplier: number;
    createdAt: Date;
    updatedAt: Date;
}

export interface IJumboLoanLimit {
    _id: string;
    year: number;
    fips: string;
    county: string;
    state: string;
    loan_limit: number;
}

export const RateTypes = [
    "30-Year Fixed",
    "30-Year Fixed FHA",
    "30-Year Fixed VA",
    "30-Year Fixed Jumbo",
    "15-Year Fixed",
] as const;

export type TRateType = (typeof RateTypes)[number];

export const PollyHistoricalRateTypes = [
    "30 YEAR FHA",
    "30 YEAR CONFORMING",
    "15 YEAR CONFORMING",
    "OTHER",
    "30 YEAR JUMBO",
    "30 YEAR VA",
] as const;

export type TPollyHistoricalRatesType = (typeof PollyHistoricalRateTypes)[number];

export const RATE_TYPE_TO_POLLY_PRODUCT_MAP: {
    [key in Exclude<TRateType, null>]?: TPollyHistoricalRatesType;
} = {
    "30-Year Fixed": "30 YEAR CONFORMING",
    "30-Year Fixed FHA": "30 YEAR FHA",
    "30-Year Fixed VA": "30 YEAR VA",
    "30-Year Fixed Jumbo": "30 YEAR JUMBO",
    "15-Year Fixed": "15 YEAR CONFORMING",
};

export interface IDailyHistoricalRates {
    _id: string;
    product: TPollyHistoricalRatesType;
    locked_at: string;
    average_rate_today: number;
}

export interface ISeedLoansQueue {
    nmls_id: string;
    user_id: string;
    processedAt: Date | null;
}
